import '../Styles/utilsStyle.css';

function AboutUs() {
    return (
        <div className="mainContainer">
            <h1>About Us</h1>

            <p>
                Big Circle Auctions (BCA) is created by a network of people and groups with offices globally. Management
                has formed a relationship with an online community (Corporation) that has over 1,500 members and is
                growing. This very strategic relationship has led BCA to where we are now, creating an auction platform
                which allows everyone to acquire high-value items that can be accomplished while saving from 25–60% of
                normal market pricing. The key to this platform is that there are no losers, making this very different
                from any other auction site you have ever seen or participated in.
            </p>

            <h3>BE A STRATEGIC BIDDER.</h3>

            <h3>Minimum Requirement</h3>

            <p>
                Each potential Bidder should automatically assume that there are at least 25 Bidders (could be 500) for
                a particular item being sold and that the presumed value of that item has no relevance to the minimum
                requirement needed for the auction to advance to call for a best and final offer...
            </p>

            <p><strong>Please note: Each best and final offer is private.</strong></p>

            <ul>
                <li><strong>Step 1:</strong> Enrolling for the auctioned item of interest...</li>
                <li><strong>Step 2:</strong> When BCA feels enough enrollees have entered, the auction is announced.</li>
                <li><strong>Step 3:</strong> Round 1 service fee posted and repeated until minimum is met or auction called short.</li>
                <li>There will always be at least four rounds, minimum service fee $10.00.</li>
                <li>Once minimum is met, BCA calls for Best & Final and winners are announced.</li>
                <li>Accumulated service fees can be applied in Best & Final if you win.</li>
            </ul>

            <p>
                Look for A+ Offering label auction items.
                Please contact the office nearest to you for more information.
            </p>
        </div>
    );
}

export default AboutUs;
